export const buildConfig = (authToken,params=undefined) => {
    return {
        headers: { 
            Authorization: `Bearer ${authToken}`,
        },
        params,
    }
}